import Vue from "vue";
import { BasePlugin, ExtraPlugin } from "stylemix-base";

Vue.use(BasePlugin);
Vue.use(ExtraPlugin, {
  googleKey: GOOGLE_KEY,
});
